import {AvastBrand} from "./AvastBrand";

class Brand {
    static get instance() {
        switch (process.env.REACT_APP_BRAND.trim()) {
            default:
                return AvastBrand;
        }
    }
}

export default Brand;
